import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumCountry implements BaseEnumType {
  private static allValues: EnumCountry[] = []; // make sure this is top-most
  
  public static none = new EnumCountry(0, "None", "enum_country_none");
  public static uk = new EnumCountry(1, "Uk", "enum_country_uk");
  public static germany = new EnumCountry(2, "Germany", "enum_country_germany");
  public static australia = new EnumCountry(3, "Australia", "enum_country_australia");
  public static southAfrica = new EnumCountry(4, "SouthAfrica", "enum_country_south_africa");
  public static sweden = new EnumCountry(5, "Sweden", "enum_country_sweden");
  public static us = new EnumCountry(6, "Us", "enum_country_us");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumCountry.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumCountry.none; }
  public isUk() { return this === EnumCountry.uk; }
  public isGermany() { return this === EnumCountry.germany; }
  public isAustralia() { return this === EnumCountry.australia; }
  public isSouthAfrica() { return this === EnumCountry.southAfrica; }
  public isSweden() { return this === EnumCountry.sweden; }
  public isUs() { return this === EnumCountry.us; }

  public static getValues(): readonly EnumCountry[] {
    return EnumCountry.allValues;
  }

  public static getValuesExcept0(): readonly EnumCountry[] {
    return EnumCountry.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumCountry {
    const found = EnumCountry.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumCountry - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumCountry): EnumCountry {
    const found = name ? EnumCountry.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumCountry - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumCountry>): boolean {
    return this.key === other?.key;
  }
}